export const ModalInformes = ({children, isOpen, closeModal}) => {

  const handleModalContainerClick = e => e.stopPropagation()
  
  return (
    <article className={`modal-informes ${isOpen && "is-open"}`} onClick={closeModal}>
      <div className="modal-container-informes" onClick={handleModalContainerClick}>
      <button className="modal-close-informes cancelButton" onClick={closeModal}>X</button>
        {children}
      </div>
    </article>
  )
}